var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('b-card',[_vm._v(" postulantes "),_c('br'),_vm._v(" "+_vm._s(this.$route.params.IdProgramSeason)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }